"use client";
import { getGlobalClassNames } from "./get-global-class-names/get-global-class-names.mjs";
import { getOptionsClassNames } from "./get-options-class-names/get-options-class-names.mjs";
import { getResolvedClassNames } from "./get-resolved-class-names/get-resolved-class-names.mjs";
import { getRootClassName } from "./get-root-class-name/get-root-class-name.mjs";
import { getSelectorClassName } from "./get-selector-class-name/get-selector-class-name.mjs";
import { getStaticClassNames } from "./get-static-class-names/get-static-class-names.mjs";
import { getVariantClassName } from "./get-variant-class-name/get-variant-class-name.mjs";
import cx from "clsx";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-class-name.ts
function getClassName({ theme, options, themeName, selector, classNamesPrefix, resolvedClassNames, resolvedThemeClassNames, classes, unstyled, className, rootSelector, props, stylesCtx, withStaticClasses, headless, transformedStyles }) {
	return cx(getGlobalClassNames({
		theme,
		options,
		unstyled: unstyled || headless
	}), resolvedThemeClassNames.map((m) => m[selector]), getVariantClassName({
		options,
		classes,
		selector,
		unstyled: unstyled || headless
	}), resolvedClassNames[selector], getResolvedClassNames({
		selector,
		stylesCtx,
		theme,
		classNames: transformedStyles,
		props
	}), getOptionsClassNames({
		selector,
		stylesCtx,
		options,
		props,
		theme
	}), getRootClassName({
		rootSelector,
		selector,
		className
	}), getSelectorClassName({
		selector,
		classes,
		unstyled: unstyled || headless
	}), withStaticClasses && !headless && getStaticClassNames({
		themeName,
		classNamesPrefix,
		selector,
		withStaticClass: options?.withStaticClass
	}), options?.className);
}
//#endregion
export { getClassName };

//# sourceMappingURL=get-class-name.mjs.map